import React, { useState } from "react";
import {
  withStyles,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core/styles";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ButtonNexto from "../controls/buttons/Button";
import Button from "@material-ui/core/Button";
const styles = (theme) => ({
  root: {
    margin: 0,
    maxWidth: 320,
    paddingBottom: 0,
  },
  rootDelete: {
    margin: 0,
    maxWidth: 620,
    paddingBottom: 0,
  },
  rootStudents: {
    margin: 0,
    maxWidth: 920,
    paddingBottom: 0,
  },
  title: {
    fontWeight: 25,
    fontSize: 19,
    color: "#303030",
  },
  deleteTitle: {
    fontWeight: 30,
    fontSize: 24,
    color: "#045AFA",
  },
  legend: {
    fontSize: 15,
    color: "#7A7A7A",
  },
  deleteLegend: {
    fontWeight: 30,
    fontSize: 22,
    color: "#333333",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const ButtonCustom = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    padding: "7px 30px",
    border: "1px solid",
    borderRadius: 20,
    lineHeight: 1.5,
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      boxShadow: "none",
      fontSize: 16,
    },
  },
})(Button);

const ButtonDelete = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    padding: "13px 24px",
    border: "1px solid",
    borderRadius: 8,
    lineHeight: 1.5,
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      boxShadow: "none",
      fontSize: 16,
    },
  },
})(Button);
const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  secondary: {
    borderColor: "#F03D3E",
    backgroundColor: "#fff",
    color: "#F03D3E",
  },
  delete: {
    borderColor: "#FF7367",
    backgroundColor: "#FF7367",
    color: "#FFFFFF",
  },
  confirm: {
    borderColor: "#FF7367",
    backgroundColor: "#045AFA",
    color: "#FFFFFF",
  },
  deleteCancel: {
    borderColor: "#F3F5F9",
    backgroundColor: "#F3F5F9",
    color: "#045AFA",
  },
  default: {
    borderColor: "#8D8D8D",
    color: "#8D8D8D",
    backgroundColor: "#fff",
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography className={classes.title} variant="h6">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContentText = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogContentText disableTypography className={classes.root} {...other}>
      <Typography className={classes.legend}>{children}</Typography>
    </MuiDialogContentText>
  );
});

const DeleteTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.rootDelete} {...other}>
      <Typography className={classes.deleteTitle} variant="h6">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DeleteContentText = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogContentText disableTypography className={classes.rootDelete} {...other}>
      <Typography className={classes.deleteLegend}>{children}</Typography>
    </MuiDialogContentText>
  );
});
const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent: "space-evenly",
    flexDirection: "row-reverse",
  },
}))(MuiDialogActions);

const DialogContent = withStyles((theme) => ({
  root: {
    paddingBottom: 10,
    fontSize: 20,
  },
}))(MuiDialogContent);

const StudentContent = withStyles((theme) => ({
  root: {
    paddingBottom: 10,
    fontSize: 20,
    maxWidth: 920,
  },
}))(MuiDialogContent);
const Dialog = withStyles((theme) => ({
  paperWidthSm: {
    borderRadius: 20,
    padding: 13,
  },
}))(MuiDialog);

const StudentDialogBox = withStyles((theme) => ({
  paperWidthSm: {
    maxWidth: 920,
    borderRadius: 20,
    padding: 13,
  },
}))(MuiDialog);

export default function AlertDialog({
  open,
  title,
  legend,
  style,
  buttonConfirmation = true,
  actionConfirmation = null,
  textConfirmation = "Continuar",
  actionCancel = null,
}) {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{`${title}`}</DialogTitle>
        {legend && (
          <DialogContent>
            <DialogContentText>{`${legend}`}</DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          {buttonConfirmation && (
            <ButtonCustom
              variant="outlined"
              color="secondary"
              className={classes.secondary}
              onClick={actionConfirmation}
            >
              {textConfirmation}
            </ButtonCustom>
          )}
          <ButtonCustom
            variant="outlined"
            color="default"
            className={classes.default}
            onClick={actionCancel}
          >
            Cancelar
          </ButtonCustom>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export function DeleteDialog({
  open,
  title,
  legend,
  style,
  type = 'delete',
  buttonConfirmation = true,
  actionConfirmation = null,
  textConfirmation = null,
  textCancel = null,
  actionCancel = null,
}) {
  const classes = useStyles();


  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DeleteTitle>{`${title}`}</DeleteTitle>
        {legend && (
          <DialogContent>
            <DeleteContentText>{`${legend}`}</DeleteContentText>
          </DialogContent>
        )}
        <DialogActions>

          {buttonConfirmation && (
            <ButtonDelete
              variant="contained"
              color="secondary"
              className={type == 'delete' ? classes.delete : classes.confirm}
              onClick={actionConfirmation}
            >
              {textConfirmation ? `${textConfirmation}` : "Continuar"}
            </ButtonDelete>
          )}

          <ButtonDelete
            variant="contained"
            color="default"
            className={classes.deleteCancel}
            onClick={actionCancel}
          >
            {textCancel ? textCancel : "Cancelar"}
          </ButtonDelete>


        </DialogActions>
      </Dialog>
    </div>
  );
}

export function StudentDialog({
  open,
  title,
  legend,
  content,
  size = 'small',
  buttonConfirmation = true,
  actionConfirmation = null,
  textConfirmation = null,
  textCancel = null,
  actionCancel = null,
}) {
  const classes = useStyles();


  return (
    <div>
      {size == 'small' ?
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DeleteTitle onClose={actionCancel}>{`${title}`}</DeleteTitle>
          {content && size == 'small' && (
            <DialogContent>
              {content}
            </DialogContent>
          )}
          {content && size == 'big' && (
            <StudentContent>
              {content}
            </StudentContent>
          )}
          <DialogActions>





          </DialogActions>
        </Dialog>
        :
        <StudentDialogBox
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DeleteTitle onClose={actionCancel}>{`${title}`}</DeleteTitle>
          {content && size == 'small' && (
            <DialogContent>
              {content}
            </DialogContent>
          )}
          {content && size == 'big' && (
            <StudentContent>
              {content}
            </StudentContent>
          )}
          <DialogActions>





          </DialogActions>
        </StudentDialogBox>
      }


    </div>
  );
}
